import { render, staticRenderFns } from "./faqPage.vue?vue&type=template&id=9976abfa&scoped=true"
import script from "./faqPage.vue?vue&type=script&lang=js"
export * from "./faqPage.vue?vue&type=script&lang=js"
import style0 from "./faqPage.vue?vue&type=style&index=0&id=9976abfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9976abfa",
  null
  
)

export default component.exports